import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';


@Component({
  selector: 'app-test-management',
  templateUrl: './test-management.component.html',
  styleUrls: ['./test-management.component.scss']
})
export class TestManagementComponent implements OnInit {

  @ViewChild('testupdatemodal', { static: false }) public testupdatemodal: ModalDirective;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  langs=[];
  tableconfig={};
  tableheaders=[];
  tabledata=[];
  userid:any;
  testid:any;
  testnamee="";
  testnameh="";
  testnamem="";
  testshortname="";
  isactive="";
  message="";
  whocanm="";
  whocanh="";
  whocane="";
  aboutm="";
  abouth="";
  aboute="";
  testname="";
  testnamevalue=""
  langvalue:number=3;
  whocan="";
  about="";
  testcharges:any;
  noneditable:any;
  showLoader: boolean = false;
  selectedlang:number = 3;
  previousvalue="e";
  isActive="";
  constructor(private router: Router, private datePipe:DatePipe, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.headerName = "Test Management";
    }, 80);
    this.getAllUsers();

    this.getAllTests();
    this.langs=[
      {
        seo_val:3,
        text_val:"English"
      },
      {
        seo_val:2,
        text_val:"Hindi"
      },
      {
        seo_val:1,
        text_val:"Marathi"
      }
    ];
    this.testname="English"

  this.selectedlang = 3;
  
    
   
  }
  checkdefalutvalue(){
// console.log("helo");
    
   
    if(this.selectedlang == 1){
      this.testname="Marathi";
      this.testnamevalue=this.testnamem;
      this.whocan=this.whocanm;
      this.about=this.aboutm;
    }
    else if(this.selectedlang == 3){
          this.testname="English";
          this.testnamevalue=this.testnamee;
          this.whocan=this.whocane;
          this.about=this.aboute;
    }
  }
  getAllUsers(){
    
    //this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getAllRegisterUserList";
   

    this.commonServices.getMethod(apiUrl).subscribe(successResp => {
     // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {    
       let tableheaders = successResp["Data"][0]["@Oritbl"]["tableheaders"];
       let tableconfig = successResp["Data"][0]["@Oritbl"]["tableconfig"];
       let tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
        this.checkUserisAdmin();
        //this.downloadtestmodal.show();
       // this.showGtPlusTbl = true;

      }
    })
  }
  checkUserisAdmin(){
    let id=this.dataManipSrvc.userId;
    for(let i=0;i<this.tabledata.length;i++){
      if(this.tabledata[i]["userid"]==id){
        if(this.tabledata[i]["usertype"]!="A")
        this.router.navigateByUrl("/dashboard");
      }
    }
  }
  getAllTests(){
    let apiUrl = this.configSetting.getBaseUrl() + "user/getTestMasterList";
  

    this.commonServices.getMethod(apiUrl).subscribe(successResp => {
     // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {    
        this.tableheaders = successResp["Data"]["tbljson"]["tableheaders"];
        this.tableconfig = successResp["Data"]["tbljson"]["tableconfig"];
        this.tabledata = successResp["Data"]["tbljson"]["tabledata"];
        this.tableconfig['dragdrop']['columns'] = false;

        //this.downloadtestmodal.show();
       // this.showGtPlusTbl = true;
      // this.tableconfig['actioncolmconfig']['print']=false;
      }
    })
  }
  edittestupdatemodal(event){
// console.log(event,"event");
    this.selectedlang = event.row.langlaid?event.row.langlaid:3;
    this.testid=event.row.testid;
    for(let i=0;i<this.tabledata.length;i++){
      if(this.tabledata[i]['testid']==this.testid){
        this.testshortname=this.tabledata[i]["testname"]["testshortname"];
        this.testnamee=this.tabledata[i]["testname"]["testnamee"];
        this.testnameh=this.tabledata[i]["testname"]["testnameh"];
        this.testnamem=this.tabledata[i]["testname"]["testnamem"];
        this.testcharges=this.tabledata[i]["testcharges"];
        this.aboute=this.tabledata[i]["abouttest"]["about"]["aboute"];
        this.abouth=this.tabledata[i]["abouttest"]["about"]["abouth"];
        this.aboutm=this.tabledata[i]["abouttest"]["about"]["aboutm"];
        this.whocane=this.tabledata[i]["abouttest"]["whocan"]["whocane"];
        this.whocanh=this.tabledata[i]["abouttest"]["whocan"]["whocanh"];
        this.whocanm=this.tabledata[i]["abouttest"]["whocan"]["whocanm"];
        this.testnamevalue=this.testnamee;
        this.whocan=this.whocane;
        this.about=this.aboute;
        //this.isactive=this.tabledata[i]["isactive"]
        this.isactive=this.tabledata[i]["isactive"];
        if(this.isactive=="Yes"){
          this.isActive="Y"
        }
        else{
          this.isActive="N";
        }
      
      }
    }
    this.noneditable=false;
    this.testname="English";
    this.testupdatemodal.show();
  }
  viewtestdetails(event){
    this.noneditable=true;
    this.testid=event.row.testid;
    for(let i=0;i<this.tabledata.length;i++){
      if(this.tabledata[i]['testid']==this.testid){
        this.testshortname=this.tabledata[i]["testname"]["testshortname"];
        this.testnamee=this.tabledata[i]["testname"]["testnamee"];
        this.testnameh=this.tabledata[i]["testname"]["testnameh"];
        this.testnamem=this.tabledata[i]["testname"]["testnamem"];
        this.testcharges=this.tabledata[i]["testcharges"];
        this.aboute=this.tabledata[i]["abouttest"]["about"]["aboute"];
        this.abouth=this.tabledata[i]["abouttest"]["about"]["abouth"];
        this.aboutm=this.tabledata[i]["abouttest"]["about"]["aboutm"];
        this.whocane=this.tabledata[i]["abouttest"]["whocan"]["whocane"];
        this.whocanh=this.tabledata[i]["abouttest"]["whocan"]["whocanh"];
        this.whocanm=this.tabledata[i]["abouttest"]["whocan"]["whocanm"];
        this.testnamevalue=this.testnamee;
        this.whocan=this.whocane;
        this.about=this.aboute;
        this.testname="English";
        //this.isactive=this.tabledata[i]["isactive"]
        this.isactive=this.tabledata[i]["isactive"];
        if(this.isactive=="Yes"){
          this.isActive="Y"
        }
        else{
          this.isActive="N";
        }
      }
  // console.log(this.isActive);
    }
    this.testupdatemodal.show();
  }
  editTest(){
    this.showLoader = true;
    /*if(this.langvalue==2){
     // this.testname="Hindi";
      this.testnameh=this.testnamevalue;
      this.whocanh=this.whocan;
      this.abouth=this.about;
    }
    if(this.langvalue==1){
      //this.testname="Marathi";
      this.testnamem=this.testnamevalue;
      this.whocanm=this.whocan;
      this.aboutm=this.about;
    
    }
    if(this.langvalue==3){
     // this.testname="English";
      this.testnamee=this.testnamevalue;
      this.whocane=this.whocan;
      this.aboute=this.about;
    }*/
   
    let apiUrl = this.configSetting.getBaseUrl() + "user/updateTestMaster";
   /* this.testnamee=this.testnamee.replace(/\\/gi, "\\\\");
    this.testnamee=this.testnamee.replace(/\'/gi, "\\'");

    this.testnameh=this.testnameh.replace(/\\/gi, "\\\\");
    this.testnameh=this.testnameh.replace(/\'/gi, "\\'");

    this.testnamem=this.testnamem.replace(/\\/gi, "\\\\");
    this.testnamem=this.testnamem.replace(/\'/gi, "\\'");

    this.aboute=this.aboute.replace(/\\/gi, "\\\\");
    this.aboute=this.aboute.replace(/\'/gi, "\\'");

    this.abouth=this.abouth.replace(/\\/gi, "\\\\");
    this.abouth=this.abouth.replace(/\'/gi, "\\'");

    this.aboutm=this.aboutm.replace(/\\/gi, "\\\\");
    this.aboutm=this.aboutm.replace(/\'/gi, "\\'");

    this.whocane=this.whocane.replace(/\\/gi, "\\\\");
    this.whocane=this.whocane.replace(/\'/gi, "\\'");

    this.whocanh=this.whocanh.replace(/\\/gi, "\\\\");
    this.whocanh=this.whocanh.replace(/\'/gi, "\\'");

    this.whocanm=this.whocanm.replace(/\\/gi, "\\\\");
    this.whocanm=this.whocanm.replace(/\'/gi, "\\'");*/
    
    let body ={
      "testid":this.testid,
      "testcharges":+this.testcharges,
      "isactive":this.isActive,
      "langid":+this.selectedlang,

      "testname":
      {
        "testshortname":this.testshortname,
        "testnamem":this.testnamem,
        "testnamee":this.testnamee,
        "testnameh":this.testnameh,
      },
      "abouttest":{
        "whocan": {
          "whocanm": this.whocanm,
          "whocanh": this.whocanh,
          "whocane": this.whocane
        },
        "about": {
          "aboutm":this.aboutm,
          "abouth":this.abouth,
          "aboute":this.aboute
        }
      }

    }
// console.log("Proflie JSON: ", JSON.stringify(body));
// console.log(this.testshortname,"shortname");
    
    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        this.message="Test records updated Successfully"
        this.getAllTests();
        // this.getAllUsers();
      }
      else {
        this.message="Fail to update Test records "
      }
    })

    this. closetestupdatemodal();
    this.successModal.show();
  }
  closetestupdatemodal(){
    this.testshortname="";
    this.testnamee="";
    this.testnameh="";
    this.testnamem="";
    this.testcharges="";
    this.selectedlang=1;
// console.log(this.selectedlang,"selectedklang");
    
    this.testupdatemodal.hide()
  }
  onOptionsSelected(value:number){
// console.log("the selected value is " + value);
    // this.langvalue=value;
    this.selectedlang = value;
// console.log(value);
    
    if(value==2){
      this.testname="Hindi";
      this.testnamevalue=this.testnameh;
      this.whocan=this.whocanh;
      this.about=this.abouth;
    }
    if(value==1){
      this.testname="Marathi";
      this.testnamevalue=this.testnamem;
      this.whocan=this.whocanm;
      this.about=this.aboutm;
    
    }
    if(value==3){
      this.testname="English";
      this.testnamevalue=this.testnamee;
      this.whocan=this.whocane;
      this.about=this.aboute;
    }


}
focusOutFunctionName(){

  if(this.langvalue==2){
    this.testnameh=this.testnamevalue;
// console.log(this.testnameh);
    
   }
   if(this.langvalue==1){
    this.testnamem=this.testnamevalue;
   }
   if(this.langvalue==3){
    this.testnamee=this.testnamevalue;
    }
}
focusOutFunctionwhocan(){
  if(this.langvalue==2){
     this.whocanh=this.whocan;
       }
   if(this.langvalue==1){
      this.whocanm=this.whocan;
     }
   if(this.langvalue==3){
     this.whocane=this.whocan;
     }
}
focusOutFunctionDes(){
  if(this.langvalue==2){
    this.abouth=this.about;
   }
   if(this.langvalue==1){
     this.aboutm=this.about;
    }
   if(this.langvalue==3){
      this.aboute=this.about;
   }
}
}
